module.exports = __webpack_public_path__ + "static/media/twitter-full.42e8b349.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/twitter-full.svg
// module id = 812
// module chunks = 0